import React, { Component } from 'react'
import PropTypes from 'prop-types'

import 'typeface-roboto'

import {
  MuiThemeProvider,
  createMuiTheme
} from 'material-ui/styles'

import CssBaseline from 'material-ui/CssBaseline'

import Header from '../components/Header'
// import AutoHeader from '../components/Header/AutoHeader.js'
import Footer from '../components/Footer'
import RightsAndAttribution from '../components/RightsAndAttribution'
import ThemeSwitch from '../components/ThemeSwitch'

import './index.css'

import * as SiteConfig from '../config/Config'

const darkTheme = createMuiTheme({
  palette: {
    type: "dark",
    primary: {
      main: SiteConfig.colorScheme.darkTheme.primaryColor,
    },
    secondary: {
      main: SiteConfig.colorScheme.darkTheme.secondaryColor,
    },
    error: SiteConfig.colorScheme.darkTheme.errorColor,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
})
const lightTheme = createMuiTheme({
  palette: {
    type: "light",
    primary: {
      main: SiteConfig.colorScheme.darkTheme.primaryColor,
    },
    secondary: {
      main: SiteConfig.colorScheme.darkTheme.secondaryColor,
    },
    error: SiteConfig.colorScheme.darkTheme.errorColor,
    contrastThreshold: 3,
    tonalOffset: 0.2,
  },
})

class TemplateWrapper extends Component {
  state = {
    currentTheme: 'light'
  }
  render(){

    const {
      children,
      data,
    } = this.props

    let theme = this.state.currentTheme === 'light' ? lightTheme : darkTheme

    return (
      <MuiThemeProvider theme={theme}>
        <div>
          <CssBaseline />
          <ThemeSwitch
            currentTheme={this.state.currentTheme}
            onThemeChange={this.changeTheme}
          />
          <Header />
          {/* <AutoHeader
          pages={
              data.allSitePage.edges.map(({ node }) => node.path).filter(page => page !== "/404/" && page !== "/dev-404-page/" && page !== "/404.html")}
          /> */}
          {children()}
          <Footer />
          <RightsAndAttribution />
        </div>
      </MuiThemeProvider>
    )
  }

  changeTheme = () => {
    let newTheme = this.state.currentTheme === 'light' ? 'dark' : 'light'
    this.setState({
      currentTheme: newTheme
    })
  }

}

TemplateWrapper.propTypes = {
  children: PropTypes.func.isRequired,
}

export default TemplateWrapper

// export const query = graphql`
//   query TemplateQuery {
//   allSitePage {
//     edges {
//       node {
//         path
//       }
//     }
//   }
// }
// `


// WEBPACK FOOTER //
// ./src/layouts/index.js